import api from './index'

export default {
    async register(data) {
        const response = await api.post("/professionals", data)
        return response
    },
    async getAll() {
        const response = await api.get("/professionals")
        return response
    },
    async getProfessional(id) {
        const response = await api.get(`/professionals/${id}`)
        return response
    },
    async edit(id, data) {
        const response = await api.put(`/professionals/${id}`, data)
        return response
    },
    async delete(id) {
        const response = await api.delete(`/professionals/${id}`)
        return response
    }
}